import NrTooltip from '../NrTooltip/NrTooltip';
export default {
  name: 'NrBar',
  components: {
    NrTooltip: NrTooltip
  },
  props: {
    values: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      } // [{ label: string, color: string, value: number }]
    },
    tooltips: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    totalCount: function totalCount() {
      return this.values.reduce(function (sum, _ref) {
        var value = _ref.value;
        sum = sum + value;
        return sum;
      }, 0);
    }
  },
  methods: {
    getPercentage: function getPercentage(val) {
      return val / this.totalCount * 100;
    },
    getBarStyles: function getBarStyles(item) {
      return {
        width: "".concat(this.getPercentage(item.value), "%"),
        backgroundColor: item.color
      };
    }
  }
};